module.exports = __webpack_public_path__ + "static/media/icons.0ab54153.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/icons.woff2
// module id = 4404
// module chunks = 0